<template>
    <nav class="flex items-start justify-center flex-wrap gap-x-2 gap-y-3">
        <button
            v-for="(item, index) in displaySteps"
            :key="item.key"
            type="button"
            class="flex flex-col items-center w-20"
            :class="item.clickable ? 'cursor-pointer' : 'cursor-default'"
            :disabled="!item.clickable"
            @click="onStepClick(item)"
        >
            <span
                class="w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium border-2 transition"
                :class="dotClasses(item)"
            >
                <template v-if="item.status === 'locked-view'">🔒</template>
                <template v-else-if="item.status === 'completed'">✓</template>
                <template v-else>{{ index + 1 }}</template>
            </span>
            <span
                class="text-xs mt-1 text-center leading-tight"
                :class="
                    item.status === 'current'
                        ? 'text-theme-primary font-semibold'
                        : item.status === 'disabled'
                        ? 'text-theme-disabled'
                        : 'text-theme-muted'
                "
            >
                {{ item.label }}
            </span>
        </button>
    </nav>
</template>

<script>
import { mapGetters } from "vuex";

const STEP_LABELS = {
    slug: "Nombre",
    "business-type": "Tipo de negocio",
    theme: "Tema",
    branding: "Marca",
    "social-networks": "Redes sociales",
    products: "Productos",
    "custom-links": "Enlaces",
    plan: "Plan"
};

export default {
    name: "OnboardingStepDots",

    props: {
        currentStep: {
            type: String,
            required: true
        }
    },

    computed: {
        ...mapGetters("onboarding", [
            "orderedSteps",
            "reachableSteps",
            "isStepCompleted",
            "isStepLocked"
        ]),
        displaySteps() {
            return this.orderedSteps.map((key) => {
                let status = "disabled";
                if (key === this.currentStep) {
                    status = "current";
                } else if (this.isStepCompleted(key)) {
                    status = this.isStepLocked(key)
                        ? "locked-view"
                        : "completed";
                } else if (this.reachableSteps.includes(key)) {
                    status = "reachable";
                }
                return {
                    key,
                    label: STEP_LABELS[key] || key,
                    status,
                    clickable: status !== "disabled" && status !== "current"
                };
            });
        }
    },

    methods: {
        dotClasses(item) {
            if (item.status === "current") {
                return "bg-theme-primary border-theme-primary text-white";
            }
            if (item.status === "disabled") {
                return "border-theme-border text-theme-disabled bg-theme-card";
            }
            return "border-theme-primary text-theme-primary bg-theme-card";
        },
        onStepClick(item) {
            if (!item.clickable) return;
            this.$emit("navigate", item.key);
        }
    }
};
</script>
